import RoutesByLayout from '../components/routes/RoutesByLayout';

export default function NotAuthorizedLayout() {
  return <RoutesByLayout />;
}
